import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'profilePicture'})
export class ProfilePicturePipe implements PipeTransform {
  transform(picture: string): string {
    return (picture) ? picture : 'assets/img/blank-profile.jpeg';
  }
}
